<div class="flex flex-col h-full gap-4">
  @if (
    this.reportingState.versions.isLoading() &&
    !this.reportingState.versions.hasValue()
  ) {
    <div class="flex flex-row gap-3 items-center">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="24"
        color="primary"
      />
      <p class="text-xs text-content-interactive-subdued">
        {{ 'REPORTING.LOADING' | translate }}
      </p>
    </div>
  } @else if (this.reportingState.versions.error()) {
    <pm-loading-failed-hint />
  } @else {
    @let readyVersions = this.reportingState.reportingReadyVersions();
    @let importableVersions = this.reportingState.importableVersions();

    @if (readyVersions.length === 0 && importableVersions.length === 0) {
      <p class="text-sm text-content-interactive-subdued">
        {{ 'REPORTING.SELECT_VERSIONS_HINT' | translate }}
      </p>
    } @else {
      <pm-reporting-toolbar
        [reportingReadyVersions]="readyVersions"
        [importableVersions]="importableVersions"
        [additionalTimeSeriesNames]="additionalTimeSeriesNames()"
      />

      @if (this.reportingState.isLoadingReportingData()) {
        <div class="flex flex-row gap-3 items-center">
          <mat-progress-spinner
            mode="indeterminate"
            [diameter]="24"
            color="primary"
          />
          <p class="text-xs text-content-interactive-subdued">
            {{ 'REPORTING.GRID.LOADING_DATA' | translate }}
          </p>
        </div>
      } @else if (this.reportingState.reportingDataError()) {
        <pm-loading-failed-hint />
      } @else {
        @let meta = this.reportingState.reportingMeta();
        @if (meta) {
          <pm-reporting-grid
            [reportingMeta]="meta"
            [metadata]="meta.metadata"
          />
        }
      }
    }
  }
</div>
